export * from './IconFolderOpen';
